import { Component, Input } from '@angular/core';

export type BannerVariant = 'teal' | 'amber' | 'red' | 'none';

@Component({
  selector: 'app-edit-mode-banner',
  standalone: false,
  templateUrl: './edit-mode-banner.component.html',
  styleUrls: ['./edit-mode-banner.component.scss'],
})
export class EditModeBannerComponent {
  @Input() variant: BannerVariant = 'none';
  @Input() message: string = '';
  @Input() subMessage: string = '';
}
